import { sessaoFetchLoading, sessaoFetch } from '@/service/fetch'

export async function getPlanosAssinaturas () {
  return sessaoFetchLoading('consig', '/Planos_Assinaturas/ListarAssinaturasOrdenado')
}

export async function editPlanosAssinaturas (dados) {
  return sessaoFetchLoading('consig', '/Planos_Assinaturas/AtualizarTodos', 'PUT', dados)
}

export async function getPlanosControle () {
  return sessaoFetchLoading('consig', '/Planos_Controle/ListarPlanosControle')
}
export async function editTodosPlanosControle (dados) {
  return sessaoFetchLoading('consig', '/Planos_Controle/AtualizarTodos', 'PUT', dados)
}
export async function inativarPlano (dados) {
  return sessaoFetchLoading('consig', '/Planos_Controle/InativarPlano', 'PUT', dados)
}
export async function buscarPlanosControle (dados) {
  if (dados === null) {
    return sessaoFetch('consig', '/planos_controle/buscarativos')
  } else {
    return sessaoFetch('consig', '/planos_controle/buscarativos/' + dados, 'GET')
  }
}



// WEBPACK FOOTER //
// ./src/api/planosassinaturas.js